import { combineEpics } from 'redux-observable';

import refreshEpics from '../../../refresh/refresh-epic';
import dataViewEpic from '../../../data-view/dataview-epic';

import caseEpics from './case-epic';
import uiEpics from './ui-epic';
import dataEpics from './data-epic';
import historyEpics from './history-epic';
import miscEpics from './misc-epic';
import insightEpics from './insight-epic';
import dashboardEpics from './dashboard-epic';
import objectEpics from './object-epic';

export default combineEpics(
  ...refreshEpics,
  ...caseEpics,
  ...uiEpics,
  ...historyEpics,
  ...dataEpics,
  ...dataViewEpic,
  ...miscEpics,
  ...insightEpics,
  ...dashboardEpics,
  ...objectEpics
);
